module.exports = __webpack_public_path__ + "img/371.eb204741.jpg";